import requestManager from "@/utils/medical-university";
// 发送短信验证码接口
export function onFetchMessage(params) {
    return requestManager
        .request({
            url: "/user/sendSecurityCode",
            method: "post",
            data: params
        });
}
// （内勤端）登录(现有接口)
export function onLoginWithPhone(params) {
    return requestManager
        .request({
            url: "/user/loginOrRegister",
            method: "post",
            data: params
        });
}
// （内勤端）查询现有的客户列表
export function onSelectXinWeiLaiCustomer(params) {
    return requestManager
        .request({
            url: "/user/selectXinWeiLaiCustomer",
            method: "post",
            data: params
        });
}
// （内勤端）新增山医大检测人员
export function onAddXinWeiLaiDetectionCustomer(params) {
    return requestManager
        .request({
            url: "/user/addXinWeiLaiDetectionCustomer",
            method: "post",
            data: params
        });
}
export function onSelectJiaJiHuaCustomer(params) {
    return requestManager
        .request({
            url: "/user/selectJiaJiHuaCustomer",
            method: "post",
            data: params
        });
}
// （业务员端）发起支付接口
export function onGetPayConfigByWechatXinWeiLai(params) {
    return requestManager
        .request({
            url: "/orgPay/getPayConfigByWechatXinWeiLai",
            method: "post",
            data: params
        });
}
export function onGetPayConfigByWechatJiaJiHua(params) {
    return requestManager
        .request({
            url: "/orgPay/getPayConfigByWechatJiaJiHua",
            method: "post",
            data: params
        });
}
// （内勤端）扫码绑定
export function onBindNumber(params) {
    return requestManager
        .request({
            url: "/user/bindNumber",
            method: "post",
            data: params
        });
}
export function onBindJiaJiHuaNumber(params) {
    return requestManager
        .request({
            url: "/user/bindJiaJiHuaNumber",
            method: "post",
            data: params
        });
}
// 采血上传
export function onConfirmCertImg(params) {
    return requestManager
        .request({
            url: "/user/uploadCertImg",
            method: "post",
            data: params
        });
}
// 甲基化内勤上传知情同意书，使用独立接口校验机构并保存到甲基化样品记录。
export function onConfirmJiaJiHuaCertImg(params) {
    return requestManager
        .request({
            url: "/user/uploadJiaJiHuaCertImg",
            method: "post",
            data: params
        });
}
// （内勤端）采血核销接口
export function onCompleteCheck(params) {
    return requestManager
        .request({
            url: "/user/completeCheck",
            method: "post",
            data: params
        });
}
export function onCompleteJiaJiHuaCheck(params) {
    return requestManager
        .request({
            url: "/user/completeJiaJiHuaCheck",
            method: "post",
            data: params
        });
}
export function onCompleteJiaJiHuaCheckBatch(params) {
    return requestManager
        .request({
            url: "/user/completeJiaJiHuaCheckBatch",
            method: "post",
            data: params
        });
}
// （内勤端）查询现有的客户详情
export function onSelectXinWeiLaiCustomerDetail(params) {
    return requestManager
        .request({
            url: "/user/selectXinWeiLaiCustomerDetail",
            method: "post",
            data: params
        });
}
export function onSelectJiaJiHuaCustomerDetail(params) {
    return requestManager
        .request({
            url: "/user/selectJiaJiHuaCustomerDetail",
            method: "post",
            data: params
        });
}
// （客户端）查询当前登录人下面的客户信息
export function onSelectXinWeiLaiPersonPrivilegeList(params) {
    return requestManager
        .request({
            url: "/user/selectXinWeiLaiPersonPrivilegeList",
            method: "post",
            data: params
        });
}
// （邮寄端）查询邮寄列表
export function onSelectExpressCustomer(params) {
    return requestManager
        .request({
            url: "/user/selectExpressCustomer",
            method: "post",
            data: params
        });
}
export function onSelectJiaJiHuaExpressCustomer(params) {
    return requestManager
        .request({
            url: "/user/selectJiaJiHuaExpressCustomer",
            method: "post",
            data: params
        });
}
// （邮寄端）邮寄确认接口
export function onConfirmExpress(params) {
    return requestManager
        .request({
            url: "/user/confirmCheck",
            method: "post",
            data: params
        });
}
export function onConfirmJiaJiHuaCheck(params) {
    return requestManager
        .request({
            url: "/user/confirmJiaJiHuaCheck",
            method: "post",
            data: params
        });
}
// （邮寄端）取消确认接口
export function onUnConfirmExpress(params) {
    return requestManager
        .request({
            url: "/user/unConfirmCheck",
            method: "post",
            data: params
        });
}
export function onUnConfirmJiaJiHuaCheck(params) {
    return requestManager
        .request({
            url: "/user/unConfirmJiaJiHuaCheck",
            method: "post",
            data: params
        });
}
// （邮寄端）写入快递单号接口
export function onExpressCheck(params) {
    return requestManager
        .request({
            url: "/user/expressCheck",
            method: "post",
            data: params
        });
}
export function onJiaJiHuaExpressCheck(params) {
    return requestManager
        .request({
            url: "/user/jiaJiHuaExpressCheck",
            method: "post",
            data: params
        });
}
// （业务员端）校验身份证是否正确接口
export function onCheckIdCard(params) {
    return requestManager
        .request({
            url: "/user/checkIdCard",
            method: "post",
            data: params
        });
}
export function onDeleteJjhPrivilege(params) {
    return requestManager
        .request({
            url: "/user/deleteJjhPrivilege",
            method: "post",
            data: params
        });
}
// （内勤端）删除新未来权益接口
export function onDeleteXwlPrivilege(params) {
    return requestManager
        .request({
            url: "/user/deleteXwlPrivilege",
            method: "post",
            data: params
        });
}
